//import Login from 'views/Login';
import Login from 'views/NewLogin';
//import Registration from 'views/Registration';
import Registration from 'views/Registration_new';
//import Registration from 'views/Registration_new_one';
import ResetPassword from 'views/ResetPassword';
import SetPassword from 'views/SetPassword';
//import ForgotPassword from 'views/ForgotPassword';
import ForgotPassword from 'views/ForgotPassword_new';
//import LandingPage from '../views/LandingPage';
//import LandingPage from '../views/LandingPage_new';
import LandingPage from '../views/LandingPage_new_one';
//import LandingPage from '../views/LandingPage_new_two';
import CandidateRegistration from '../views/home/CandidateRegistration';
import RegistrationMessage from '../views/RegistrationMessage';
import InvalidLicenceError from '../views/InvalidLicenceError';

// Admin Pages
import Dashboard from '../views/admin/Dashboard';
// Sprint 2.4 (Enterprise Configuration / Governance / Compliance Center experiences)
import EnterpriseConfiguration from '../views/admin/EnterpriseConfiguration';
// Phase C.2 (Enterprise Language Configuration Foundation)
import LanguageConfiguration from '../views/admin/LanguageConfiguration_new';
// Phase R6.5 (Admin-Configurable Payment Gateway)
import PaymentGatewayConfiguration from '../views/admin/PaymentGatewayConfiguration_new';
import GovernanceRequests from '../views/admin/GovernanceRequests';
import ComplianceCenter from '../views/admin/ComplianceCenter';
//import AdminLogin from '../views/AdminLogin';
import AdminLogin from '../views/AdminLogin_new';
import PostMaster from '../views/admin/PostMaster';
//import CategoryMaster from '../views/admin/CategoryMaster';
import CategoryMaster from '../views/admin/CategoryMaster_new';
//import UniversityMaster from '../views/admin/UniversityMaster';
import UniversityMaster from '../views/admin/UniversityMaster_new';
//import DegreeMaster from '../views/admin/DegreeMaster';
import DegreeMaster from '../views/admin/DegreeMaster_new';
//import SpecializationMaster from '../views/admin/SpecializationMaster';
import SpecializationMaster from '../views/admin/SpecializationMaster_new';
//import ChallanBankDetailMaster from '../views/admin/ChallanBankDetailMaster';
import ChallanBankDetailMaster from '../views/admin/ChallanBankDetailMaster_new';
//import CandidatesList from '../views/admin/CandidatesList';
import CandidatesList from '../views/admin/CandidatesList_new';
//import CenterMaster from '../views/admin/CenterMaster';
import CenterMaster from '../views/admin/CenterMaster_new';
//import BatchMaster from '../views/admin/BatchMaster';
import BatchMaster from '../views/admin/BatchMaster_new';
//import UploadBankTransactions from '../views/admin/UploadBankTransactions';
import UploadBankTransactions from '../views/admin/UploadBankTransactions_new';
//import ExportAttendanceSheet from '../views/admin/ExportAttendanceSheet';
import ExportAttendanceSheet from '../views/admin/ExportAttendanceSheet_new';
//import ExportCandidates from '../views/admin/ExportCandidates';
import ExportCandidates from '../views/admin/ExportCandidates_new';
//import GenerateRollNumbers from '../views/admin/GenerateRollNumbers';
import GenerateRollNumbers from '../views/admin/GenerateRollNumbers_new';
//import AssignCenter from '../views/admin/AssignCenter';
import AssignCenter from '../views/admin/AssignCenter_new';
//import PortalConfiguration from '../views/admin/PortalConfiguration';
import PortalConfiguration from '../views/admin/PortalConfiguration_new';
// Phase C.1 (Enterprise Publication Foundation)
import PublicationMaster from '../views/admin/PublicationMaster_new';
// Phase C.9 (Answer Key & Lightweight Online Objection Workflow)
import AnswerKeyMaster from '../views/admin/AnswerKeyMaster_new';
import AnswerKeyObjectionMaster from '../views/admin/AnswerKeyObjectionMaster_new';
// Phase B (Interview Scheduling)
import InterviewScheduleMaster from '../views/admin/InterviewScheduleMaster_new';
// Recruitment Candidate-List Publication Modernization phase
import EligibleCandidateList from '../views/admin/EligibleCandidateList_new';
// Primary Result Automation & Interview Shortlisting phase
import InterviewShortlist from '../views/admin/InterviewShortlist_new';
// Interview Marks Workflow & Final Result Foundation phase
import FinalResult from '../views/admin/FinalResult_new';
//import TransactionsList from '../views/admin/TransactionsList';
import TransactionsList from '../views/admin/TransactionsList_new';
//import PostConfiguration from '../views/admin/PostConfiguration';
import PostConfiguration from '../views/admin/PostConfiguration_new';
//import ExportPhotoSignature from '../views/admin/ExportPhotoSignature';
import ExportPhotoSignature from '../views/admin/ExportPhotoSignature_new';
//import UploadResult from '../views/admin/UploadResult';
import UploadResult from '../views/admin/UploadResult_new';
//import UploadInterviewResult from '../views/admin/UploadInterviewResult';
import UploadInterviewResult from '../views/admin/UploadInterviewResult_new';
//import QuestionAnswer from '../views/admin/QuestionAnswer';
import QuestionAnswer from '../views/admin/QuestionAnswer_new';
//import UploadTransactionsData from '../views/helpdeskAdmin/UploadTransactionsData';
import UploadTransactionsData from '../views/helpdeskAdmin/UploadTransactionsData_new';
import SendBulkHallTicketSMS from '../views/admin/SendBulkHallTicketSMS';
import RetryHallTicketSMS from '../views/admin/RetryHallTicketSMS';
import RetryInterviewCallLetterDownloadSMS from '../views/admin/RetryInterviewCallLetterDownloadSMS';
import SendBulkInterviewCallLetterDownloadSMS from '../views/admin/SendBulkInterviewCallLetterDownloadSMS';
import SendBulkHallTicketEmail from '../views/admin/SendBulkHallTicketEmail';
import RetryHallTicketEmail from '../views/admin/RetryHallTicketEmail';
import SendBulkInterviewCallLetterDownloadEmail from '../views/admin/SendBulkInterviewCallLetterDownloadEmail';
import RetryInterviewCallLetterDownloadEmail from '../views/admin/RetryInterviewCallLetterDownloadEmail';

//import AkshepData from '../views/admin/AkshepData';
import AkshepData from '../views/admin/AkshepData_new';
//import ViewCandidateInfo from '../views/ViewCandidateInfo';
import ViewCandidateInfo from '../views/ViewCandidateInfo_new';
//import ViewExamCardByAdmin from '../views/ViewExamCardByAdmin';
import ViewExamCardByAdmin from '../views/ViewExamCardByAdmin_new';
//import GenerateAtendance from '../views/admin/GenerateAtendance';
import GenerateAtendance from '../views/admin/GenerateAtendance_new';
//import UploadAttendance from '../views/admin/UploadAttendance';
import UploadAttendance from '../views/admin/UploadAttendance_new';
//import NewAttendanceSheet from '../views/admin/NewAttendanceSheet';
import NewAttendanceSheet from '../views/admin/NewAttendanceSheet_new';
//import sendBulkViewResultEmail from "../views/admin/SendBulkViewResultEmail";
import sendBulkViewResultEmail from "../views/admin/SendBulkViewResultEmail_new";
//import SendBulkViewResultSMS from '../views/admin/SendBulkViewResultSMS';
import SendBulkViewResultSMS from '../views/admin/SendBulkViewResultSMS_new';

//import UploadCenterBatchData from '../views/admin/UploadCenterBatchData';
import UploadCenterBatchData from '../views/admin/UploadCenterBatchData_new';
//import UploadCenterBatchLabCountData from '../views/admin/UploadCenterBatchLabCountData';
import UploadCenterBatchLabCountData from '../views/admin/UploadCenterBatchLabCountData_new';
//import ViewCenterBatchData from '../views/admin/ViewCenterBatchData';
//import ViewCenterBatchData from '../views/admin/ViewCenterBatchData_new';
import ViewCenterBatchData from '../views/admin/ViewCenterBatchData_new';

//import ViewCenterBatchLabCountData from '../views/admin/ViewCenteBatchLabCountData';
import ViewCenterBatchLabCountData from '../views/admin/ViewCenteBatchLabCountData_new';
//import ExportCenterWiseAttendanceData from '../views/admin/ExportCenterWiseAttendanceData';
import ExportCenterWiseAttendanceData from '../views/admin/ExportCenterWiseAttendanceData_new';
 
import UploadStudentAppointmentData from "../views/admin/UploadStudentAppointmentData";
import ViewStudentAppointmentData from "../views/admin/ViewStudentAppointmentData";



//import UploadStudentInterviewTimeData from '../views/admin/UploadStudentInterviewTimeData';
import UploadStudentInterviewTimeData from '../views/admin/UploadStudentInterviewTimeData_new';
//import ViewStudentInterviewTimeData from '../views/admin/ViewStudentInterviewTimeData';
import ViewStudentInterviewTimeData from '../views/admin/ViewStudentInterviewTimeData_new';
import License from '../views/admin/License';

// Terms & Conditions, Contact Us, About Us
import SharedPage from '../views/T&CPages/SharedPage';
//import BankAdminLogin from '../views/BankAdminLogin';
import BankAdminLogin from '../views/BankAdminLogin_new';
//import CandidateDetails from '../views/bankAdmin/CandidateDetails';
import CandidateDetails from '../views/bankAdmin/CandidateDetails_new';
//import HelpDeskLogin from '../views/HelpDeskLogin';
import HelpDeskLogin from '../views/HelpDeskLogin_new';
//import CandidatesListInHelpDesk from '../views/helpdeskAdmin/CandidatesListInHelpDesk';
import CandidatesListInHelpDesk from '../views/helpdeskAdmin/CandidatesListInHelpDesk_new';
import AfterPayment from '../views/AfterPayment';
import BiometricAdminLogin from '../views/BiometricAdminLogin';
import InitializedNSDL from '../views/BiometricAdmin/InitializedNSDL';


export const routes = {
    login: {
        path: "/",
        basePath: "/",
        component: LandingPage,
        roles: null,
        menuId: ''
    },
    registration: {
        path: "/registration",
        basePath: "/registration",
        component: Registration,
        // component: LandingPage,
        roles: null,
        menuId: ''
    },
    invalidlicenceerror: {
        path: "/InvalidLicence",
        basePath: "/InvalidLicence",
        component: InvalidLicenceError,
        // component: LandingPage,
        roles: null,
        menuId: ''
    },
    resetPassword: {
        path: "/reset-password/:token",
        basePath: "/reset-password",
        component: ResetPassword,
        // component: LandingPage,
        roles: null,
        menuId: ''
    },
    setPassword: {
        path: "/set-password/:token",
        basePath: "/set-password",
        component: SetPassword,
        // component: LandingPage,
        roles: null,
        menuId: ''
    },
    forgotPassword: {
        path: "/forgot-password",
        basePath: "/forgot-password",
        component: ForgotPassword,
        // component: LandingPage,
        roles: null,
        menuId: ''
    },
    registrationComplete: {
        path: "/registrationComplete",
        basePath: "/registrationComplete",
        component: RegistrationMessage,
        // component: LandingPage,
        roles: null,
        menuId: 'RegistrationComplete'
    },
    home: {
        path: "/home",
        basePath: "/home",
        component: CandidateRegistration,
        //component: LandingPage,
        roles: null,
        menuId: ''
    },
    // landing: {
    //     path: "/",
    //     basePath: "/",
    //     component: LandingPage,
    //     roles: null,
    //     menuId: 'Landing'
    // },
    aboutUs: {
        path: "/aboutus",
        basePath: "/aboutus",
        component: SharedPage,
        // component: LandingPage,
        roles: null,
        menuId: ''
    },
    contactUs: {
        path: "/contactus",
        basePath: "/contactus",
        component: SharedPage,
        // component: LandingPage,
        roles: null,
        menuId: ''
    },
    privacyPolicy: {
        path: "/privacypolicy",
        basePath: "/privacypolicy",
        component: SharedPage,
        // component: LandingPage,
        roles: null,
        menuId: ''
    },
    termsAndConditions: {
        path: "/termsandconditions",
        basePath: "/termsandconditions",
        component: SharedPage,
        // component: LandingPage,
        roles: null,
        menuId: ''
    },
    cancellationRefundPolicies: {
        path: "/refundpolicies",
        basePath: "/refundpolicies",
        component: SharedPage,
        // component: LandingPage,
        roles: null,
        menuId: ''
    },
    afterPayment : {
        path: "/transactionprocess",
        basePath: "/transactionprocess",
        component: AfterPayment,
        roles: null,
        menuId: ''
    }

}

export const routesAdmin = {
    adminlogin: {
        path: "/admin/login",
        basePath: "/admin/login",
        component: AdminLogin,
        roles: null,
        menuId: 'adminlogin'
    },
    dashboard: {
        path: "/admin/dashboard",
        basePath: "/admin/dashboard",
        component: Dashboard,
        roles: null,
        menuId: 'dashboard'
    },
    // Sprint 2.4 (Enterprise Configuration / Governance / Compliance Center experiences) — consume
    // Sprint 2.2/2.3 backend APIs that had no frontend route before this sprint.
    enterpriseconfig: {
        path: "/admin/enterpriseconfig",
        basePath: "/admin/enterpriseconfig",
        component: EnterpriseConfiguration,
        roles: null,
        menuId: 'enterpriseconfig'
    },
    // Phase C.2 (Enterprise Language Configuration Foundation)
    languageconfiguration: {
        path: "/admin/languageconfiguration",
        basePath: "/admin/languageconfiguration",
        component: LanguageConfiguration,
        roles: null,
        menuId: 'languageconfiguration'
    },
    // Phase R6.5 (Admin-Configurable Payment Gateway)
    paymentgatewayconfiguration: {
        path: "/admin/paymentgatewayconfiguration",
        basePath: "/admin/paymentgatewayconfiguration",
        component: PaymentGatewayConfiguration,
        roles: null,
        menuId: 'paymentgatewayconfiguration'
    },
    governance: {
        path: "/admin/governance",
        basePath: "/admin/governance",
        component: GovernanceRequests,
        roles: null,
        menuId: 'governance'
    },
    compliancecenter: {
        path: "/admin/compliancecenter",
        basePath: "/admin/compliancecenter",
        component: ComplianceCenter,
        roles: null,
        menuId: 'compliancecenter'
    },
    portalconfiguration: {
        path: "/admin/portalconfiguration",
        basePath: "/admin/portalconfiguration",
        component: PortalConfiguration,
        roles: null,
        menuId: 'portalconfiguration'
    },
    // Phase C.1 (Enterprise Publication Foundation)
    publication: {
        path: "/admin/publication",
        basePath: "/admin/publication",
        component: PublicationMaster,
        roles: null,
        menuId: 'publication'
    },
    // Phase C.9 (Answer Key & Lightweight Online Objection Workflow)
    answerkey: {
        path: "/admin/answerkey",
        basePath: "/admin/answerkey",
        component: AnswerKeyMaster,
        roles: null,
        menuId: 'answerkey'
    },
    answerkeyobjection: {
        path: "/admin/answerkeyobjection",
        basePath: "/admin/answerkeyobjection",
        component: AnswerKeyObjectionMaster,
        roles: null,
        menuId: 'answerkeyobjection'
    },
    // Phase B (Interview Scheduling)
    interviewschedule: {
        path: "/admin/interviewschedule",
        basePath: "/admin/interviewschedule",
        component: InterviewScheduleMaster,
        roles: null,
        menuId: 'interviewschedule'
    },
    // Recruitment Candidate-List Publication Modernization phase
    eligiblecandidatelist: {
        path: "/admin/eligiblecandidatelist",
        basePath: "/admin/eligiblecandidatelist",
        component: EligibleCandidateList,
        roles: null,
        menuId: 'eligiblecandidatelist'
    },
    // Primary Result Automation & Interview Shortlisting phase
    interviewshortlist: {
        path: "/admin/interviewshortlist",
        basePath: "/admin/interviewshortlist",
        component: InterviewShortlist,
        roles: null,
        menuId: 'interviewshortlist'
    },
    // Interview Marks Workflow & Final Result Foundation phase
    finalresult: {
        path: "/admin/finalresult",
        basePath: "/admin/finalresult",
        component: FinalResult,
        roles: null,
        menuId: 'finalresult'
    },
    postconfiguration: {
        path: "/admin/postconfiguration/:postID?",
        basePath: "/admin/postconfiguration",
        component: PostConfiguration,
        roles: null,
        menuId: 'postconfiguration'
    },
    post: {
        path: "/admin/post",
        basePath: "/admin/post",
        component: PostMaster,
        roles: null,
        menuId: 'post'
    },
    category: {
        path: "/admin/category",
        basePath: "/admin/category",
        component: CategoryMaster,
        roles: null,
        menuId: 'category'
    },
    university: {
        path: "/admin/university",
        basePath: "/admin/university",
        component: UniversityMaster,
        roles: null,
        menuId: 'university'
    },
    degree: {
        path: "/admin/degree",
        basePath: "/admin/degree",
        component: DegreeMaster,
        roles: null,
        menuId: 'degree'
    },
    specialization: {
        path: "/admin/specialization",
        basePath: "/admin/specialization",
        component: SpecializationMaster,
        roles: null,
        menuId: 'specialization'
    },
    challanbankdetails: {
        path: "/admin/challanbankdetails",
        basePath: "/admin/challanbankdetails",
        component: ChallanBankDetailMaster,
        roles: null,
        menuId: 'challanbankdetails'
    },
    candidateslist: {
        path: "/admin/candidateslist",
        basePath: "/admin/candidateslist",
        component: CandidatesList,
        roles: null,
        menuId: 'candidateslist'
    },
    center: {
        path: "/admin/center",
        basePath: "/admin/center",
        component: CenterMaster,
        roles: null,
        menuId: 'center'
    },
    batch: {
        path: "/admin/batch",
        basePath: "/admin/batch",
        component: BatchMaster,
        roles: null,
        menuId: 'batch'
    },
    banktransactions: {
        path: "/admin/banktransactions",
        basePath: "/admin/banktransactions",
        component: UploadBankTransactions,
        roles: null,
        menuId: 'banktransactions'
    },
    exportcandidates: {
        path: "/admin/exportcandidates",
        basePath: "/admin/exportcandidates",
        component: ExportCandidates,
        roles: null,
        menuId: 'exportcandidates'
    },
    exportattendance: {
        path: "/admin/exportattendance",
        basePath: "/admin/exportattendance",
        component: ExportAttendanceSheet,
        roles: null,
        menuId: 'exportattendance'
    },
    generaterollnumbers: {
        path: "/admin/generaterollnumbers",
        basePath: "/admin/generaterollnumbers",
        component: GenerateRollNumbers,
        roles: null,
        menuId: 'generaterollnumbers'
    },
    assigncenter: {
        path: "/admin/assigncenter",
        basePath: "/admin/assigncenter",
        component: AssignCenter,
        roles: null,
        menuId: 'assigncenter'
    },
    transactionsList: {
        path: "/admin/transactions",
        basePath: "/admin/transactions",
        component: TransactionsList,
        roles: null,
        menuId: 'transactions'
    },
    exportPhotoSignature: {
        path: "/admin/exportphotosignature",
        basePath: "/admin/exportphotosignature",
        component: ExportPhotoSignature,
        roles: null,
        menuId: 'exportphotosignature'
    },
    sendBulkHallTicketSMS: {
        path: "/admin/sendBulkHallTicketSMS",
        basePath: "/admin/sendBulkHallTicketSMS",
        component: SendBulkHallTicketSMS,
        roles: null,
        menuId: 'SendBulkHallTicketSMS'
    },
    retryHallTicketSMS: {
        path: "/admin/retryHallTicketSMS",
        basePath: "/admin/retryHallTicketSMS",
        component: RetryHallTicketSMS,
        roles: null,
        menuId: 'retryHallTicketSMS'
    },
    sendBulkHallTicketEmail: {
        path: "/admin/sendBulkHallTicketEmail",
        basePath: "/admin/sendBulkHallTicketEmail",
        component: SendBulkHallTicketEmail,
        roles: null,
        menuId: 'SendBulkHallTicketEmail'
    },
    retryHallTicketEmail: {
        path: "/admin/retryHallTicketEmail",
        basePath: "/admin/retryHallTicketEmail",
        component: RetryHallTicketEmail,
        roles: null,
        menuId: 'RetryHallTicketEmail'
    },
    sendBulkSMSForInterviewCallLetterDownload: {
        path: "/admin/sendBulkSMSForInterviewCallLetterDownload",
        basePath: "/admin/sendBulkSMSForInterviewCallLetterDownload",
        component: SendBulkInterviewCallLetterDownloadSMS,
        roles: null,
        menuId: 'sendBulkSMSForInterviewCallLetterDownload'
    },
    retryInterviewCallLetterDownloadSMS: {
        path: "/admin/retryInterviewCallLetterDownloadSMS",
        basePath: "/admin/retryInterviewCallLetterDownloadSMS",
        component: RetryInterviewCallLetterDownloadSMS,
        roles: null,
        menuId: 'retryInterviewCallLetterDownloadSMS'
    },
    sendBulkEmailForInterviewCallLetterDownload: {
        path: "/admin/sendBulkEmailForInterviewCallLetterDownload",
        basePath: "/admin/sendBulkEmailForInterviewCallLetterDownload",
        component: SendBulkInterviewCallLetterDownloadEmail,
        roles: null,
        menuId: 'sendBulkEmailForInterviewCallLetterDownload'
    },
    retryEmailForInterviewCallLetterDownload: {
        path: "/admin/retryEmailForInterviewCallLetterDownload",
        basePath: "/admin/retryEmailForInterviewCallLetterDownload",
        component: RetryInterviewCallLetterDownloadEmail,
        roles: null,
        menuId: 'retryEmailForInterviewCallLetterDownload'
    },
    uploadResult: {
        path: "/admin/uploadResult",
        basePath: "/admin/uploadResult",
        component: UploadResult,
        roles: null,
        menuId: 'uploadResult'
    },
    uploadInterviewResult: {
        path: "/admin/uploadInterviewResult",
        basePath: "/admin/uploadInterviewResult",
        component: UploadInterviewResult,
        roles: null,
        menuId: 'uploadInterviewResult'
    },
    questionAnswer: {
        path: "/admin/questionAnswer",
        basePath: "/admin/questionAnswer",
        component: QuestionAnswer,
        roles: null,
        menuId: 'questionAnswer'
    },
    viewCandidateInfo: {
        path: "/admin/viewCandidateInfo",
        basePath: "/admin/viewCandidateInfo",
        component: ViewCandidateInfo,
        roles: null,
        menuId: 'viewCandidateInfo'
    },
    viewExamCardByAdmin: {
        path: "/admin/viewExamCardByAdmin",
        basePath: "/admin/viewExamCardByAdmin",
        component: ViewExamCardByAdmin,
        roles: null,
        menuId: 'viewExamCardByAdmin'
    },
    newattendancesheet: {
        path: "/admin/newattendancesheet",
        basePath: "/admin/newattendancesheet",
        component: NewAttendanceSheet,
        roles: null,
        menuId: 'newattendancesheet'
    },
    generateatendance: {
        path: "/admin/generateatendance",
        basePath: "/admin/generateatendance",
        component: GenerateAtendance,
        roles: null,
        menuId: 'generateatendance'
    },
    uploadAttendance:{
        path: "/admin/uploadAttendance",
        basePath: "/admin/uploadAttendance",
        component: UploadAttendance,
        roles: null,
        menuId: 'uploadAttendance'
    },
    // Golden Journey Certification cleanup: this block was a byte-for-byte duplicate of the
    // `retryHallTicketSMS` key already defined above (~line 514) — harmless (the later object-literal
    // key silently won), but dead duplication. Removed rather than left in place.
    sendBulkViewResultEmail: {
        path: "/admin/sendBulkViewResultEmail",
        basePath: "/admin/sendBulkViewResultEmail",
        component: sendBulkViewResultEmail,
        roles: null,
        menuId: 'sendBulkViewResultEmail'
    },
    sendBulkViewResultSMS: {
        path: "/admin/sendBulkViewResultSMS",
        basePath: "/admin/sendBulkViewResultSMS",
        component: SendBulkViewResultSMS,
        roles: null,
        menuId: 'sendBulkViewResultSMS'
    },
    akshepData: {
        path: "/admin/akshepData",
        basePath: "/admin/akshepData",
        component: AkshepData,
        roles: null,
        menuId: 'akshepData'
    },
    uploadCenterBatchData:{
        path: "/admin/uploadCenterBatchData",
        basePath: "/admin/uploadCenterBatchData",
        component: UploadCenterBatchData,
        roles: null,
        menuId: 'uploadCenterBatchData'
    },
    uploadCenterBatchLabCountData:{
        path: "/admin/uploadCenterBatchLabCountData",
        basePath: "/admin/uploadCenterBatchLabCountData",
        component: UploadCenterBatchLabCountData,
        roles: null,
        menuId: 'uploadCenterBatchLabCountData'
    },
    viewCenterBatchData:{
        path: "/admin/viewCenterBatchData",
        basePath: "/admin/viewCenterBatchData",
        component: ViewCenterBatchData,
        roles: null,
        menuId: 'viewCenterBatchData'
    },
    viewCenterBatchLabCountData:{
        path: "/admin/viewCenterBatchLabCountData",
        basePath: "/admin/viewCenterBatchLabCountData",
        component: ViewCenterBatchLabCountData,
        roles: null,
        menuId: 'viewCenterBatchLabCountData'
    },
    exportCenterWiseAttendanceData:{
        path: "/admin/exportCenterWiseAttendanceData",
        basePath: "/admin/exportCenterWiseAttendanceData",
        component: ExportCenterWiseAttendanceData,
        roles: null,
        menuId: 'exportCenterWiseAttendanceData'
    },
    uploadStudentAppointmentData:{
        path: "/admin/uploadStudentAppointmentData",
        basePath: "/admin/uploadStudentAppointmentData",
        component: UploadStudentAppointmentData,
        roles: null,
        menuId: 'uploadStudentAppointmentData'
    },
    viewStudentAppointmentData:{
        path: "/admin/viewStudentAppointmentData",
        basePath: "/admin/viewStudentAppointmentData",
        component: ViewStudentAppointmentData,
        roles: null,
        menuId: 'viewStudentAppointmentData'
    },
    uploadStudentInterviewTimeData:{
        path: "/admin/uploadStudentInterviewTimeData",
        basePath: "/admin/uploadStudentInterviewTimeData",
        component: UploadStudentInterviewTimeData,
        roles: null,
        menuId: 'uploadStudentInterviewTimeData'
    },
    viewStudentInterviewTimeData:{
        path: "/admin/viewStudentInterviewTimeData",
        basePath: "/admin/viewStudentInterviewTimeData",
        component: ViewStudentInterviewTimeData,
        roles: null,
        menuId: 'viewStudentInterviewTimeData'
    },
    license: {
        path: "/admin/license",
        basePath: "/admin/license",
        component: License,
        roles: null,
        menuId: 'license'
    },
}

export const routesBankAdmin = {
    bankadminlogin: {
        path: "/bankadmin/login",
        basePath: "/bankadmin/login",
        component: BankAdminLogin,
        roles: null,
        menuId: 'bankadminlogin'
    },
    candidatedetails: {
        path: "/bankadmin/candidatedetails",
        basePath: "/bankadmin/candidatedetails",
        component: CandidateDetails,
        roles: null,
        menuId: 'candidatedetails'
    }, 
   
}

export const routesHelpDeskAdmin = {
    helpdeskadminlogin: {
        path: "/helpDeskAdmin/login",
        basePath: "/helpDeskAdmin/login",
        component: HelpDeskLogin,
        roles: null,
        menuId: 'helpdeskadminlogin'
    },
    uploadTransactionsData: {
        path: "/helpDeskAdmin/uploadTransactionsData",
        basePath: "/helpDeskAdmin/uploadTransactionsData",
        component: UploadTransactionsData,
        roles: null,
        menuId: 'uploadTransactionsData'
    },
    candidateListInHelpDesk: {
        path: "/helpDeskAdmin/candidateList",
        basePath: "/helpDeskAdmin/candidateList",
        component: CandidatesListInHelpDesk,
        roles: null,
        menuId: 'candidateListInHelpDesk'
    },
}


export const routesBiometricAdmin = {
    biometricadminlogin: {
        path: "/biometricadmin/login",
        basePath: "/biometricadmin/login",
        component: BiometricAdminLogin,
        roles: null,
        menuId: 'biometricadminlogin'
    },
   initializedNSDL: {
        path: "/biometricadmin/initializedNSDL",
        basePath: "/biometricadmin/initializedNSDL",
        component: InitializedNSDL,
        roles: null,
        menuId: 'initializedNSDL'
    }, 
    
}

export const publicViews = [
    routes.login,
    routesAdmin.adminlogin,
    routesBankAdmin.bankadminlogin,
    routesHelpDeskAdmin.helpdeskadminlogin,
    routesBiometricAdmin.biometricadminlogin,
    routes.registration,
    routes.resetPassword,
    routes.setPassword,
    routes.forgotPassword,
    // routes.landing,
    routes.registrationComplete,
    routes.aboutUs,
    routes.contactUs,
    routes.privacyPolicy,
    routes.termsAndConditions,
    routes.cancellationRefundPolicies,
    routes.invalidlicenceerror,
    
];

export const privateViews = [
    routes.home,
    routes.afterPayment

];

export const adminViews = [
    routesAdmin.dashboard,
    routesAdmin.enterpriseconfig,
    routesAdmin.languageconfiguration,
    routesAdmin.paymentgatewayconfiguration,
    routesAdmin.governance,
    routesAdmin.compliancecenter,
    routesAdmin.post,
    routesAdmin.category,
    routesAdmin.university,
    routesAdmin.degree,
    routesAdmin.specialization,
    routesAdmin.challanbankdetails,
    routesAdmin.candidateslist,
    routesAdmin.center,
    routesAdmin.batch,
    routesAdmin.banktransactions,
    routesAdmin.exportcandidates,
    routesAdmin.exportattendance,
    routesAdmin.generaterollnumbers,
    routesAdmin.assigncenter,
    routesAdmin.portalconfiguration,
    routesAdmin.publication,
    routesAdmin.answerkey,
    routesAdmin.answerkeyobjection,
    routesAdmin.interviewschedule,
    routesAdmin.eligiblecandidatelist,
    routesAdmin.interviewshortlist,
    routesAdmin.finalresult,
    routesAdmin.transactionsList,
    routesAdmin.postconfiguration,
    routesAdmin.exportPhotoSignature,
    routesAdmin.sendBulkHallTicketSMS,
    routesAdmin.retryHallTicketSMS,
    routesAdmin.sendBulkSMSForInterviewCallLetterDownload,
    routesAdmin.sendBulkEmailForInterviewCallLetterDownload,
    routesAdmin.retryEmailForInterviewCallLetterDownload,
    routesAdmin.retryInterviewCallLetterDownloadSMS,
    routesAdmin.sendBulkHallTicketEmail,
    routesAdmin.retryHallTicketEmail,
    routesAdmin.uploadResult,
    routesAdmin.uploadInterviewResult,
    routesAdmin.questionAnswer,
    routesAdmin.akshepData,
    routesAdmin.viewCandidateInfo,
    routesAdmin.viewExamCardByAdmin,
    routesAdmin.newattendancesheet,
    routesAdmin.generateatendance,
    routesAdmin.uploadAttendance,

    routesAdmin.sendBulkViewResultEmail,
    routesAdmin.sendBulkViewResultSMS,

    routesAdmin.uploadCenterBatchData,
    routesAdmin.uploadCenterBatchLabCountData,
    routesAdmin.viewCenterBatchData,
    routesAdmin.viewCenterBatchLabCountData,
    routesAdmin.exportCenterWiseAttendanceData,
    
    routesAdmin.uploadStudentInterviewTimeData,
    routesAdmin.viewStudentInterviewTimeData,

    routesAdmin.uploadStudentAppointmentData,
    routesAdmin.viewStudentAppointmentData,

    routesAdmin.license,
];

export const bankAminViews = [
    routesBankAdmin.candidatedetails
];

export const helpDeskAdminViews = [
    routesHelpDeskAdmin.uploadTransactionsData,
    routesHelpDeskAdmin.candidateListInHelpDesk
];

export const biometricAdminViews = [
   routesBiometricAdmin.initializedNSDL
];




